export default "__VITE_ASSET__DFQ4G4KZ__"